import useLang from "../../../hooks/useLang";
import { useParams } from "react-router-dom";
import useParticipant from "./useParticipant";
import useParticipants from "./useParticipants";
//import useDiagnoses from "../../diagnoses/hooks/useDiagnoses";

const useParticipantBlock = (participantIdFromProps) => {
  const lang = useLang();
  const { participantId } = useParams();
  const participant = useParticipant({
    id: participantIdFromProps || participantId,
  });
  const participants = useParticipants();
  const iids = participants?.data?.map((participant) => participant.iid);
  
  /*
  const diagnoses = useDiagnoses();

  const participantDiagnoses = participant?.data?.known_conditions?.map(
    (condition) => {
      return diagnoses?.data?.find((diagnosis) => diagnosis.id === condition);
    }
  );

  const diagnosesOptions = diagnoses?.data?.map((diagnosis) => ({
    id: diagnosis.id,
    label: diagnosis.name,
  }));
*/

  const items = [
    {
      id: "iid",
      value: participant?.data?.iid,
      required: true,
      inputWidth: "half",
      isValid: (data) => {
        if (data === "") return true;
        const idx = iids.indexOf(data);
        return idx < 0;
      },
    },
    {
      id: "date_of_birth",
      value: participant?.data?.date_of_birth,
      required: true,
      inputWidth: "half",
      type: "date",
      isValid: (data) => {
        if (data === "") return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const date = new Date(data);
        date.setHours(0, 0, 0, 0);
        if (date > today) return false;
        const yearBorn = parseInt(data.split("_")[0]) || 0;
        return yearBorn > 1900;
      },
    },
    {
      id: "gender",
      options: [
        { id: "M", label: lang("captions.m") },
        { id: "F", label: lang("captions.f") },
      ],
      value: {
        id: participant?.data?.gender,
        label: lang(`captions.${participant?.data?.gender}`),
      },
      displayValue: lang(`captions.${participant?.data?.gender}`),
      type: "chip-radio",
      required: true,
      idAsValue: true,
    },
    /*
    {
      id: "diagnoses",
      type: "multiselector",
      value: participantDiagnoses?.map((diagnosis) => ({
        id: diagnosis.id,
        label: diagnosis.name,
      })),
      displayValue: participantDiagnoses
        ?.map((diagnosis) => diagnosis.name)
        .join(", "),
      options: diagnosesOptions,
    },
    */
  ];

  return items;
};

export default useParticipantBlock;
